import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core'
import {OrderItem} from '../../data/order-item';
import {Subject, timer} from 'rxjs';
import {MatOrderStore} from '../../data/mat-order.store';
import {Router} from '@angular/router';
import {OrdersService} from 'projects/desktop/src/app/modules/order/data/orders.service';
import {filter, takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

@Component({
  selector: 'app-material-table',
  templateUrl: './material-table.component.html',
  styleUrls: ['./material-table.component.scss']
})
@RxJSUnsubscribe
export class MaterialTableComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  items: OrderItem[];

  @Input()
  orderId: number;

  @Input()
  canBeEdited: boolean;

  @Input()
  orderStatus: string;

  @Output()
  orderIsEdited = new EventEmitter<void>();

  lastInput: HTMLInputElement

  stockMap = new Map()

  hasArea: boolean;

  constructor(
      protected el: ElementRef,
      public router: Router,
      protected matOrderStore: MatOrderStore,
      private ordersService: OrdersService
  ) {
  }

  ngOnInit(): void {
    this.canBeEdited = (this.orderStatus !== 'Confirmed' && this.orderStatus !== 'Backordered' && this.orderStatus !== 'Delivered');
    this.hasArea = this.items.some(item =>
        ['Clear Coat', 'Paint', 'Primer'].includes(item.cvMaterial.typeName)
    )

    this.ordersService.openedOrderSubj$.pipe(filter(orderId => orderId === this.orderId),
        takeUntil(this.getUnsubFromAllSubs())).subscribe(event => {
      this.getStockInfo()
    })
  }

  getStockInfo() {
    this.ordersService.getStockInfo(this.orderId).subscribe(stockInfos => {
      stockInfos.forEach(stockInfo => {
        if(!this.stockMap.has(stockInfo.cvMaterialId)) {
          this.stockMap.set(stockInfo.cvMaterialId, `${stockInfo.projectName}(${stockInfo.reserveQty})`)
        } else {
          let newStr = `${this.stockMap.get(stockInfo.cvMaterialId)}\n${stockInfo.projectName}(${stockInfo.reserveQty})`
          this.stockMap.set(stockInfo.cvMaterialId, newStr)
        }

      })
    })
  }

  roundNum(num: number) {
    return Math.floor(num * 100) / 100
  }

  clickOnEditableCell(event: MouseEvent) {
    // event.srcElement

    const fInput = (this.el.nativeElement.getElementsByClassName('material-input-text') as HTMLInputElement)

    timer(1).subscribe(emit => {
      fInput[0].select()
    })


  }

  clickOnMaterial(materialName: string) {
    this.matOrderStore.updateSearchQuery(materialName)
    this.router.navigate(['/orders/materials'])
  }

  startEdit(event) {

    const tempInputs = (this.el.nativeElement as HTMLInputElement).getElementsByClassName('material-input-text');
    if(tempInputs) {
      timer(1).subscribe(emit => {
        this.lastInput = tempInputs[0] as HTMLInputElement
        this.lastInput.focus()
        this.lastInput.setSelectionRange(0, this.lastInput.value.length);
      })
    }
  }

  onEditComplete(event) {
    this.items.forEach(item => {
      item.reservedQuantity = parseFloat(String(item.reservedQuantity));
      item.orderedQuantity = parseFloat(String(item.orderedQuantity));
      item.price = parseFloat(String(item.price));
    })

    // this.orderIsEdited.next();
  }

  onKeyPress(event) {

    // this.orderIsEdited.next();
  }


  ngOnDestroy() {
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

}
